<div
    class="anc-field"
    [class.anc-field--floating]="floating()"
    [class.anc-field--focused]="focused()"
    [class.anc-field--readonly]="readonly() || isDisplayRow()"
>
    @if (resolvedControl(); as ctrl) {
        <input
            class="form-control"
            [formControl]="ctrl"
            [type]="type()"
            [readonly]="readonly() || isDisplayRow()"
            [attr.title]="readonlyTooltip()"
            [attr.aria-label]="ariaLabel() || null"
            [attr.tabindex]="isDisplayRow() ? -1 : null"
            [attr.autocomplete]="isDisplayRow() ? 'off' : autocomplete()"
            ancFieldValidate
            [ancFieldValidateSubmitted]="validateSubmitted()"
            [ancFieldValidateForceInvalid]="forceInvalid()"
            [ancNumbersOnly]="numbersOnly() && !isDisplayRow()"
            [ancAlphaNumericOnly]="alphaNumericOnly() && !isDisplayRow()"
            [ancDecimalsOnly]="decimalsOnly() && !isDisplayRow()"
            [ancDecimalsMaxPlaces]="decimalsMaxPlaces()"
        />
    } @else if (!controlName() && !isDisplayRow()) {
        <ng-content></ng-content>
    }
    <!-- Only when there IS label text: in the floating state the label paints a
    padded, surface-coloured notch over the top border, so an empty one leaves a
    visible nick in the field outline (and a stray asterisk when required). -->
    @if (label()) {
        <label class="anc-field__label" translate
            >{{ label() }}<sup class="super-star" *ngIf="required()">*</sup></label
        >
    }
    @if (hasBuiltInErrorMessages() && showBuiltInFieldError()) {
        <div ancError>
            @if (showRequiredError()) {
                <div class="has-error" translate>{{ requiredErrorMessage() }}</div>
            }
            @if (showMaxlengthError()) {
                <div class="has-error" translate>{{ maxlengthErrorMessage() }}</div>
            }
            @if (showMinlengthError()) {
                <div class="has-error" translate>{{ minlengthErrorMessage() }}</div>
            }
            @if (showMinError()) {
                <div class="has-error" translate>{{ minErrorMessage() }}</div>
            }
            @if (showMaxError()) {
                <div class="has-error" translate>{{ maxErrorMessage() }}</div>
            }
            @if (showPatternError()) {
                <div class="has-error" translate>{{ resolvedPatternErrorMessage() }}</div>
            }
        </div>
    }
    <ng-content select="[ancError]"></ng-content>
    <ng-content select="[ancHint]"></ng-content>
</div>
